import React from "react";
import { Select } from "../../../../controls";
import { DropLi } from "../../../../hooks";

const InputReturnReason = ({ handleInpChg, item }) => {
  const { ReturnReason } = DropLi();

  return (
    <>
      <Select
        variant="outlined"
        placeholder="Select Reason"
        name="returnReason"
        size="small"
        fullWidth
        value={item.returnReason}
        onChange={(e) =>
          handleInpChg({
            id: item.id,
            name: "returnReason",
            value: e.target.value,
          })
        }
        options={[...ReturnReason.filter((j) => j.id !== 6)]}
        sx={{
          "& .MuiInputBase-root": {
            padding: "0px 0px",
          },
          "& .MuiInputBase-input": {
            padding: "5px 10px",
            textAlign: "center",
            fontSize: "14px",
          },
        }}
      />
    </>
  );
};

export default InputReturnReason;
